import { render, staticRenderFns } from "./mangerMyShop.vue?vue&type=template&id=025715ba&scoped=true"
import script from "./mangerMyShop.vue?vue&type=script&lang=js"
export * from "./mangerMyShop.vue?vue&type=script&lang=js"
import style0 from "./mangerMyShop.vue?vue&type=style&index=0&id=025715ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025715ba",
  null
  
)

export default component.exports